import { call, put, takeLatest } from 'redux-saga/effects';

import { psmAuditDigital, notification } from '../../actionTypes';
import dataProvider from '../../store/dataProvider';
import { getNotificationErrorMessage } from './helpers';

function* update({ payload: { companyId, data } }) {
  try {
    yield call(dataProvider.updateOnly, 'audit', data);
    yield put({ type: psmAuditDigital.update.end });
    yield put({ type: notification.add, payload: { success: 'Audit updated successfully' } });
    yield put({ type: psmAuditDigital.list.start, payload: { companyId } });
    if (!data.isDraft) {
      yield put({ type: psmAuditDigital.pendingCompanyRedirectSet, payload: { companyId } });
    }
  } catch (e) {
    yield put({ type: psmAuditDigital.update.error });
    yield put({ type: notification.add, payload: { error: getNotificationErrorMessage(e, 'Failed to update audit') } });
  }
}

export default function* updateSaga() {
  yield takeLatest(psmAuditDigital.update.start, update);
}
